import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-015beeb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "layer",
  "data-depth": "0.1"
}
const _hoisted_2 = {
  class: "layer",
  "data-depth": "0.3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "layer",
  "data-depth": "0.4"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "glow" })
], -1))
const _hoisted_4 = {
  class: "layer",
  "data-depth": "0.5"
}
const _hoisted_5 = {
  class: "layer",
  "data-depth": "0.7"
}

import {ref, onMounted, onUnmounted} from 'vue'

  import ResponsiveImage from '@/components/ResponsiveImage'

  import Parallax from 'parallax-js'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CalledCoral',
  setup(__props) {

  const root = ref()

  let parallax

  onMounted(() => {
    parallax = new Parallax(root.value)
  })

  onUnmounted(() => {
    parallax.destroy()
  })

  const layer1Images = [
    {
      width_px: 600,
      url: require('@/assets/responsive/coral-1-600.webp')
    },

    {
      width_px: 800,
      url: require('@/assets/responsive/coral-1-800.webp')
    },

    {
      width_px: 1000,
      url: require('@/assets/responsive/coral-1-1000.webp')
    },

    {
      width_px: 1200,
      url: require('@/assets/responsive/coral-1-1200.webp')
    }
  ]

  const layer2Images = [
    {
      width_px: 600,
      url: require('@/assets/responsive/coral-2-600.webp')
    },

    {
      width_px: 800,
      url: require('@/assets/responsive/coral-2-800.webp')
    },

    {
      width_px: 1000,
      url: require('@/assets/responsive/coral-2-1000.webp')
    },

    {
      width_px: 1200,
      url: require('@/assets/responsive/coral-2-1200.webp')
    }
  ]

  const layer3Images = [
    {
      width_px: 600,
      url: require('@/assets/responsive/coral-3-600.webp')
    },

    {
      width_px: 800,
      url: require('@/assets/responsive/coral-3-800.webp')
    },

    {
      width_px: 1000,
      url: require('@/assets/responsive/coral-3-1000.webp')
    },

    {
      width_px: 1200,
      url: require('@/assets/responsive/coral-3-1200.webp')
    }
  ]

  const layer4Images = [
    {
      width_px: 600,
      url: require('@/assets/responsive/coral-4-600.webp')
    },

    {
      width_px: 800,
      url: require('@/assets/responsive/coral-4-800.webp')
    },

    {
      width_px: 1000,
      url: require('@/assets/responsive/coral-4-1000.webp')
    },

    {
      width_px: 1200,
      url: require('@/assets/responsive/coral-4-1200.webp')
    }
  ]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "called-coral"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ResponsiveImage), {
        "image-versions": layer4Images,
        alt: "coral",
        class: "coral"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ResponsiveImage), {
        "image-versions": layer3Images,
        alt: "coral",
        class: "coral"
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(ResponsiveImage), {
        "image-versions": layer2Images,
        alt: "coral",
        class: "coral"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(ResponsiveImage), {
        "image-versions": layer1Images,
        alt: "coral",
        class: "coral"
      })
    ])
  ], 512))
}
}

})